import axios from "axios";
import { PointObjectInfo } from "../Interface/user.interface";

const getPointsDetail = async (
    userId: string
): Promise<PointObjectInfo[] | []> => {
    const config = {
        baseURL: process.env.REACT_APP_API_BASE_URL,
        params: { userId },
    };
    try {
        const res = await axios.get("/point-engine/points-detail", config);
        return res.data;
    } catch (err) {
        console.log(err);
        return [];
    }
};

export default getPointsDetail;
